import { render } from "./SubInfo.vue?vue&type=template&id=3b3b2c45"
import script from "./SubInfo.vue?vue&type=script&lang=js"
export * from "./SubInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__